export default {
  requirements: {

    "step1": [
      // step 1 

      { name: 'riderSection', status: { disabled: true, hide: true } },
      { name: 'welcomeLetterGenerateBtn', status: { disabled: true, hide: true } },
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: true, hide: true } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: false, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: true } },
      { name: 'policyNumber', status: { disabled: false, hide: false } },
      { name: 'policyReference', status: { disabled: false, hide: false } },
      { name: 'applicationDate', status: { disabled: false, hide: false } },
      { name: 'applicationReceivedDate', status: { disabled: false, hide: false } },
      { name: 'policyCurrency', status: { disabled: false, hide: false } },
      { name: 'initialPremium', status: { disabled: false, hide: false } },
      { name: 'modalPremium', status: { disabled: false, hide: false } },
      { name: 'conditionalAssignmentFlag', status: { disabled: false, hide: false, value: '' } },
      { name: 'policyTerm', status: { disabled: false, hide: false } },
      { name: 'paymentTerm', status: { disabled: false, hide: false } },
      { name: 'originalAgent', status: { disabled: false, hide: false } },
      { name: 'policyAgent', status: { disabled: false, hide: false } },
      { name: 'currentAgent', status: { disabled: false, hide: false } },
      { name: 'originalReferrer', status: { disabled: false, hide: false } },
      { name: 'policyOwner', status: { disabled: false, hide: false } },
      { name: 'insurer', status: { disabled: false, hide: false } },
      { name: 'thirdParty', status: { disabled: false, hide: false } },
      { name: 'beneficiary', status: { disabled: false, hide: false } },
      { name: 'docs', status: { disabled: false, hide: false } },
      { name: 'premiumType', status: { disabled: false, hide: false } },
      { name: 'paymentMethod', status: { disabled: false, hide: false } },
      { name: 'companyBank', status: { disabled: false, hide: false } },
      { name: 'paymentReference', status: { disabled: false, hide: false } },
      { name: 'remarks', status: { disabled: false, hide: false } },
      { name: 'sentOutDate', status: { disabled: false, hide: true } },
      { name: 'sentOutMedium', status: { disabled: false, hide: true } },
      { name: 'sentOutReference', status: { disabled: false, hide: true } },
      { name: 'issueDate', status: { disabled: false, hide: true } },
      { name: 'commencementDate', status: { disabled: false, hide: true } },
      { name: 'welcomeLetterSentOutDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: false, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: true } },

      // 
      { name: 'levy', status: { disabled: false, hide: false } },

      // { name: 'premiumAmount', status: { disabled: false, hide: false } },
      // { name: 'premiumPaid', status: { disabled: false, hide: false } },
      // { name: 'paymentAmount', status: { disabled: false, hide: false } },
      // { name: 'paymentDate', status: { disabled: false, hide: false } },
    ],

    "step2": [
      // step 2 
      { name: 'riderSection', status: { disabled: false, hide: false } },
      { name: 'welcomeLetterGenerateBtn', status: { disabled: true, hide: true } },
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: true, hide: true } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceivedDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'initialPremium', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'conditionalAssignmentFlag', status: { disabled: true, hide: false } },
      { name: 'policyTerm', status: { disabled: true, hide: false } },
      { name: 'paymentTerm', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'originalReferrer', status: { disabled: true, hide: false } },
      { name: 'policyOwner', status: { disabled: true, hide: false } },
      { name: 'insurer', status: { disabled: true, hide: false } },
      { name: 'thirdParty', status: { disabled: true, hide: false } },
      { name: 'beneficiary', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: false, hide: true } },
      { name: 'sentOutMedium', status: { disabled: false, hide: true } },
      { name: 'sentOutReference', status: { disabled: false, hide: true } },
      { name: 'issueDate', status: { disabled: false, hide: true } },
      { name: 'commencementDate', status: { disabled: false, hide: true } },
      { name: 'welcomeLetterSentOutDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: false, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: true } },

      // 
      { name: 'levy', status: { disabled: true, hide: false } },
      // { name: 'premiumAmount', status: { disabled: false, hide: false } },
      // { name: 'premiumPaid', status: { disabled: false, hide: false } },
      // { name: 'paymentAmount', status: { disabled: false, hide: false } },
      // { name: 'paymentDate', status: { disabled: false, hide: false } },
    ],
    // step 3 sent out

    "step3": [
      { name: 'riderSection', status: { disabled: false, hide: false } },
      { name: 'welcomeLetterGenerateBtn', status: { disabled: true, hide: true } },
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: false, hide: false } },

      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceivedDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'initialPremium', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'conditionalAssignmentFlag', status: { disabled: true, hide: false } },
      { name: 'policyTerm', status: { disabled: true, hide: false } },
      { name: 'paymentTerm', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'originalReferrer', status: { disabled: true, hide: false } },
      { name: 'policyOwner', status: { disabled: true, hide: false } },
      { name: 'insurer', status: { disabled: true, hide: false } },
      { name: 'thirdParty', status: { disabled: true, hide: false } },
      { name: 'beneficiary', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: false, hide: false } },
      { name: 'sentOutMedium', status: { disabled: false, hide: false } },
      { name: 'sentOutReference', status: { disabled: false, hide: false } },
      { name: 'issueDate', status: { disabled: false, hide: true } },
      { name: 'commencementDate', status: { disabled: false, hide: true } },
      { name: 'welcomeLetterSentOutDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: false, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: true } },

      // 
      { name: 'levy', status: { disabled: true, hide: false } },
      // { name: 'premiumAmount', status: { disabled: false, hide: false } },
      // { name: 'premiumPaid', status: { disabled: false, hide: false } },
      // { name: 'paymentAmount', status: { disabled: false, hide: false } },
      // { name: 'paymentDate', status: { disabled: false, hide: false } },
    ],

    // step 4 
    "step4": [

      { name: 'riderSection', status: { disabled: false, hide: false } },
      { name: 'welcomeLetterGenerateBtn', status: { disabled: true, hide: true } },
      { name: 'orSection', status: { disabled: false, hide: false } },
      { name: 'saveBtn', status: { disabled: false, hide: false } },
      { name: 'nextBtn', status: { disabled: true, hide: true } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'inforceBtn', status: { disabled: false, hide: false } },
      { name: 'rejectBtn', status: { disabled: false, hide: false } },
      { name: 'policyInfomation', status: { disabled: false, hide: false } },

      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceivedDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'initialPremium', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'conditionalAssignmentFlag', status: { disabled: true, hide: false } },
      { name: 'policyTerm', status: { disabled: true, hide: false } },
      { name: 'paymentTerm', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'originalReferrer', status: { disabled: true, hide: false } },
      { name: 'policyOwner', status: { disabled: true, hide: false } },
      { name: 'insurer', status: { disabled: true, hide: false } },
      { name: 'thirdParty', status: { disabled: true, hide: false } },
      { name: 'beneficiary', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      { name: 'issueDate', status: { disabled: false, hide: true } },
      { name: 'commencementDate', status: { disabled: false, hide: true } },
      { name: 'welcomeLetterSentOutDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: false, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: true } },

      { name: 'levy', status: { disabled: true, hide: false } },
    ],
    // step 5 

    "step5": [
      { name: 'riderSection', status: { disabled: false, hide: false } },
      { name: 'welcomeLetterGenerateBtn', status: { disabled: true, hide: true } },
      { name: 'orSection', status: { disabled: false, hide: true } },
      { name: 'saveBtn', status: { disabled: false, hide: true } },
      { name: 'nextBtn', status: { disabled: true, hide: true } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'inforceBtn', status: { disabled: false, hide: true } },
      { name: 'rejectBtn', status: { disabled: false, hide: false } },
      { name: 'policyInfomation', status: { disabled: false, hide: true } },

      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceivedDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'initialPremium', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'conditionalAssignmentFlag', status: { disabled: true, hide: false } },
      { name: 'policyTerm', status: { disabled: true, hide: false } },
      { name: 'paymentTerm', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'originalReferrer', status: { disabled: true, hide: false } },
      { name: 'policyOwner', status: { disabled: true, hide: false } },
      { name: 'insurer', status: { disabled: true, hide: false } },
      { name: 'thirdParty', status: { disabled: true, hide: false } },
      { name: 'beneficiary', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      { name: 'issueDate', status: { disabled: false, hide: true } },
      { name: 'commencementDate', status: { disabled: false, hide: true } },
      { name: 'welcomeLetterSentOutDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: false, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: true } },

      // 
      { name: 'levy', status: { disabled: true, hide: false } },
    ],
    // step 6 

    "step6": [{ name: 'riderSection', status: { disabled: false, hide: false } },
      { name: 'welcomeLetterGenerateBtn', status: { disabled: true, hide: true } },
      { name: 'orSection', status: { disabled: false, hide: true } },
      { name: 'saveBtn', status: { disabled: false, hide: true } },
      { name: 'nextBtn', status: { disabled: true, hide: true } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'inforceBtn', status: { disabled: false, hide: false } },
      { name: 'rejectBtn', status: { disabled: false, hide: true } },
      { name: 'policyInfomation', status: { disabled: false, hide: true } },

      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceivedDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'initialPremium', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'conditionalAssignmentFlag', status: { disabled: true, hide: false } },
      { name: 'policyTerm', status: { disabled: true, hide: false } },
      { name: 'paymentTerm', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'originalReferrer', status: { disabled: true, hide: false } },
      { name: 'policyOwner', status: { disabled: true, hide: false } },
      { name: 'insurer', status: { disabled: true, hide: false } },
      { name: 'thirdParty', status: { disabled: true, hide: false } },
      { name: 'beneficiary', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      { name: 'issueDate', status: { disabled: false, hide: false } },
      { name: 'commencementDate', status: { disabled: false, hide: false } },
      { name: 'welcomeLetterSentOutDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: false, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: true } },

      // 
      { name: 'levy', status: { disabled: true, hide: false } },
    ],
    // step 7 

    "step7": [{ name: 'riderSection', status: { disabled: false, hide: false } },
      { name: 'welcomeLetterGenerateBtn', status: { disabled: false, hide: false } },
      { name: 'orSection', status: { disabled: false, hide: true } },
      { name: 'saveBtn', status: { disabled: false, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: false, hide: true } },
      { name: 'inforceBtn', status: { disabled: false, hide: true } },
      { name: 'rejectBtn', status: { disabled: false, hide: true } },
      { name: 'policyInfomation', status: { disabled: false, hide: true } },

      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceivedDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'initialPremium', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'conditionalAssignmentFlag', status: { disabled: true, hide: false } },
      { name: 'policyTerm', status: { disabled: true, hide: false } },
      { name: 'paymentTerm', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: false, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'originalReferrer', status: { disabled: true, hide: false } },
      { name: 'policyOwner', status: { disabled: true, hide: false } },
      { name: 'insurer', status: { disabled: true, hide: false } },
      { name: 'thirdParty', status: { disabled: true, hide: false } },
      { name: 'beneficiary', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      { name: 'issueDate', status: { disabled: true, hide: false } },
      { name: 'commencementDate', status: { disabled: true, hide: false } },
      { name: 'welcomeLetterSentOutDate', status: { disabled: false, hide: false } },
      { name: 'companyReceiveDate', status: { disabled: false, hide: false } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: true } },

      // 
      { name: 'levy', status: { disabled: true, hide: false } },
    ],
    // step 8

    "step8": [
      { name: 'riderSection', status: { disabled: false, hide: false } },
      { name: 'welcomeLetterGenerateBtn', status: { disabled: false, hide: false } },
      { name: 'orSection', status: { disabled: false, hide: true } },
      { name: 'saveBtn', status: { disabled: false, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'inforceBtn', status: { disabled: false, hide: true } },
      { name: 'rejectBtn', status: { disabled: false, hide: true } },
      { name: 'policyInfomation', status: { disabled: false, hide: true } },

      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceivedDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'initialPremium', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'conditionalAssignmentFlag', status: { disabled: true, hide: false } },
      { name: 'policyTerm', status: { disabled: true, hide: false } },
      { name: 'paymentTerm', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: false, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'originalReferrer', status: { disabled: true, hide: false } },
      { name: 'policyOwner', status: { disabled: true, hide: false } },
      { name: 'insurer', status: { disabled: true, hide: false } },
      { name: 'thirdParty', status: { disabled: true, hide: false } },
      { name: 'beneficiary', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      { name: 'issueDate', status: { disabled: true, hide: false } },
      { name: 'commencementDate', status: { disabled: true, hide: false } },
      { name: 'welcomeLetterSentOutDate', status: { disabled: true, hide: false } },
      { name: 'companyReceiveDate', status: { disabled: true, hide: false } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: false } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: true } },
      // 
      { name: 'levy', status: { disabled: true, hide: false } },
    ],
    // step 9

    "step9": [{ name: 'riderSection', status: { disabled: false, hide: false } },
      { name: 'welcomeLetterGenerateBtn', status: { disabled: false, hide: false } },
      { name: 'orSection', status: { disabled: false, hide: true } },
      { name: 'saveBtn', status: { disabled: false, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'inforceBtn', status: { disabled: false, hide: true } },
      { name: 'rejectBtn', status: { disabled: false, hide: true } },
      { name: 'policyInfomation', status: { disabled: false, hide: true } },

      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceivedDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'initialPremium', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'conditionalAssignmentFlag', status: { disabled: true, hide: false } },
      { name: 'policyTerm', status: { disabled: true, hide: false } },
      { name: 'paymentTerm', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: false, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'originalReferrer', status: { disabled: true, hide: false } },
      { name: 'policyOwner', status: { disabled: true, hide: false } },
      { name: 'insurer', status: { disabled: true, hide: false } },
      { name: 'thirdParty', status: { disabled: true, hide: false } },
      { name: 'beneficiary', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      { name: 'issueDate', status: { disabled: true, hide: false } },
      { name: 'commencementDate', status: { disabled: true, hide: false } },
      { name: 'welcomeLetterSentOutDate', status: { disabled: true, hide: false } },
      { name: 'companyReceiveDate', status: { disabled: true, hide: false } },
      { name: 'agentReceiveDate', status: { disabled: true, hide: false } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: false } },

      // 
      { name: 'levy', status: { disabled: true, hide: false } },
    ]

  }
}



// WEBPACK FOOTER //
// ./src/Osm/LifePolicy/assets/_workflowStepRequirement.js